import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import MoreSvg from '../../svg/admin/More';
import BinSvg from '../../svg/admin/Bin';
import RemoveSvg from '../../svg/admin/Remove';
import _ from 'lodash';
import { fetchSchoolById, updateSchoolById } from '../../services2/schools.service';
import { deleteUser, fetchUserList, insertNewStudent, insertNewTeacher, updateUser } from '../../services2/users.service';
import { isValidEmail } from '../../util/utils';
import { adminChangePassword } from '../../services2/request.service';
import * as XLSX from 'xlsx';
import EditSchoolMissionsPopup from './components/EditSchoolMissionsPopup';
import { resetPasswordAndSendEmail } from '../../services2/registrations.service';

function Component(props) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setdata] = useState(null)
  const [isLoading, setisLoading] = useState(false)



  const fetchData = async () => {
    let result = await fetchSchoolById(props.token.token, id);
    if (result.result) {
      setdata(result.result)
    } else {
      console.log('Fetch data error')
    }
  }
  const [teachers, setTeachers] = useState([])
  const fetchTeahcers = async () => {
    let result = await fetchUserList(props.token.token, { schoolId: id, type: 'teacher' }, { limit: 9999 });
    if (result.result) {
      setTeachers(result.result || [])
    } else {
      console.log('Fetch data error')
    }
  }
  const [students, setStudents] = useState([])
  const fetchStudents = async () => {
    let result = await fetchUserList(props.token.token, { schoolId: id, type: 'student' }, { limit: 9999 });
    if (result.result) {
      setStudents(result.result || [])
    } else {
      console.log('Fetch data error')
    }
  }

  const handleSave = async () => {
    if (isLoading) return
    setisLoading(true)
    let result = await updateSchoolById(props.token.token, id, {
      name: data.name || '',
      data: data.data || {},
    });
    if (result.errno) {
      alert(result.message)
    } else {
      alert('儲存成功')
    }
    setisLoading(false)
  }

  const handleUpdateField = (field) => (e) => {
    setdata({ ...data, [field]: e.target.value })
  }

  const refresh = async () => {
    if (isLoading) return
    setisLoading(true)
    await fetchData()
    await fetchTeahcers()
    await fetchStudents()
    setisLoading(false)
  }

  useEffect(() => {
    refresh()
  }, [id])

  const [isAddingTeacher, setisAddingTeacher] = useState(null)
  const [isAddingStudent, setisAddingStudent] = useState(null)
  const [isDeletingUser, setisDeletingUser] = useState(null)

  const handleDeleteUser = async () => {
    setisLoading(true)
    let result = await deleteUser(props.token.token, isDeletingUser._id);
    if (result.errno) {
      alert(result.message)
    } else {
      alert('刪除成功')
      setisDeletingUser(null)
      await fetchTeahcers()
      await fetchStudents()
    }
    setisLoading(false)
  }
  const handleAddTeacher = async () => {
    if ((!isAddingTeacher.name) || isAddingTeacher.name.length < 2) {
      alert('請輸入有效的名字')
      return
    }
    if ((!isAddingTeacher.username) || (!isValidEmail(isAddingTeacher.username)) || isAddingTeacher.username.length < 5) {
      alert('請輸入有效的電子郵件')
      return
    }
    if ((!isAddingTeacher._id) && ((!isAddingTeacher.password) || isAddingTeacher.password.length < 5)) {
      alert('請輸入有效的密碼')
      return
    }
    setisLoading(true)
    let result =
      isAddingTeacher?._id ?
        await updateUser(props.token.token, isAddingTeacher._id, { name: isAddingTeacher.name, mobile: isAddingTeacher.mobile })
        : await insertNewTeacher(props.token.token, id, isAddingTeacher?.username, isAddingTeacher?.password, isAddingTeacher?.name, isAddingTeacher.mobile);
    if (result.errno) {
      alert(result.message)
    } else {
      alert(isAddingTeacher._id ? '更新成功' : '添加成功')
      setisAddingTeacher(null)
      await fetchTeahcers()
    }
    setisLoading(false)
  }
  const handleAddStudent = async () => {
    if ((!isAddingStudent.name) || isAddingStudent.name.length < 2) {
      alert('請輸入有效的名字')
      return
    }
    if ((!isAddingStudent.username) || (!isValidEmail(isAddingStudent.username)) || isAddingStudent.username.length < 5) {
      alert('請輸入有效的電子郵件')
      return
    }
    if ((!isAddingStudent._id) && ((!isAddingStudent.password) || isAddingStudent?.password.length < 5)) {
      alert('請輸入有效的密碼')
      return
    }
    if ((!isAddingStudent.gender)) {
      alert('請選擇性別')
      return
    }
    if ((!isAddingStudent.class)) {
      alert('請輸入班級')
      return
    }
    const list = [{
      username: isAddingStudent.username,
      password: isAddingStudent.password,
      class: isAddingStudent.class,
      name: isAddingStudent.name,
      gender: isAddingStudent.gender,
    }]
    setisLoading(true)
    let result =
      isAddingStudent?._id ?
        await updateUser(props.token.token, isAddingStudent._id, { name: isAddingStudent.name, class: isAddingStudent.class, gender: isAddingStudent.gender })
        : await insertNewStudent(props.token.token, id, list);
    if (result.errno) {
      alert(result.message)
    } else {
      alert(isAddingStudent._id ? '更新成功' : '添加成功')
      setisAddingStudent(null)
      await fetchStudents()
    }
    setisLoading(false)
  }

  const [isChangingPassword, setisChangingPassword] = useState(null)
  const handleChangePassword = (id) => async () => { setisChangingPassword({ userId: id }) }
  const handleConfirmChangePassword = async () => {
    if ((!isChangingPassword.password) || isChangingPassword.password.length < 5) {
      alert('請輸入有效的密碼')
      return
    }
    setisLoading(true)
    let result = await adminChangePassword(props.token.token, isChangingPassword.userId, isChangingPassword.password);
    if (result.errno) {
      alert(JSON.stringify(result.message) || '密碼更改失敗')
    } else {
      alert('密碼更改成功')
      setisChangingPassword(null)
    }
    setisLoading(false)
  }
  const openNewTab = (url) => () => {
    window.open(url, '_blank').focus();
  }

  const [isUploading, setisUploading] = useState(false)
  const handleUpload = (e) => {
    e.preventDefault();

    var files = e.target.files, f = files[0];
    var reader = new FileReader();
    reader.onload = function (e) {
      var data = e.target.result;
      let readedData = XLSX.read(data, { type: 'binary' });
      const wsname = readedData.SheetNames[0];
      const ws = readedData.Sheets[wsname];

      /* Convert array to json*/
      const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1 });
      if (dataParse.length > 999) {
        alert('m- Error Data too large');
        return
      }
      //check header			
      if (!dataParse[0] || dataParse[0].length !== 5) {
        alert('Invalid format - (invalid header length)');
        return
      }
      console.log(dataParse)
      //check missing column data
      for (let [i] of dataParse.entries())
        if (i > 0) if (!dataParse[i] || dataParse[i].length !== 5) {
          alert('missing data for row ' + (i + 1));
          return
        }

      let data_ = []
      for (let [i] of dataParse.entries())
        if (i > 0) {
          data_.push({
            username: dataParse[i][0],
            password: dataParse[i][1],
            name: dataParse[i][2],
            gender: dataParse[i][3] === 'M' || dataParse[i][3] === '男' ? '男' : '女',
            class: dataParse[i][4],
          })
        }
      setisUploading(data_)
    };
    reader.readAsArrayBuffer(f)
  }
  const handleConfirmUpload = async () => {
    if (isUploading.length < 1) {
      alert('請上傳一個Excel文件')
      return
    }

    setisLoading(true)
    let result = await insertNewStudent(props.token.token, id, isUploading);
    if (result.errno) {
      alert(JSON.stringify(result.message) || 'error')
    } else {
      alert('添加成功')
      setisUploading(null)
      await fetchStudents()
    }
    setisLoading(false)
  }

  const [isResendingEmail, setisResendingEmail] = useState(null)

  const handleResendEmail = async() => {
      let result = await resetPasswordAndSendEmail(props.token.token, isResendingEmail);
      if (result.errno) {
        alert(JSON.stringify(result.message) || 'error')
      } else {
        alert('重新發送電子郵件成功')
        setisResendingEmail(null)
      }
  }
  const [isEditingMissions, setisEditingMissions] = useState(false)

  return (
    <div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px] text-[16px] text-[black]'>
      {/*buttons*/}
      <div className='flex flex-row items-center justify-between items-center gap-[8px] flex-wrap'>
        <div className='text-[#1D1D41] text-[24px] font-[400] cursor-pointer' onClick={() => { navigate('/platform2/users') }}>{`<`} 返回</div>
        <div className='flex flex-row gap-[8px] flex-wrap '>
          {/* <div className='text-[#1F4CC8] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5]' style={{ border: '1px solid #1F4CC8' }}>刪除</div> */}
          <div onClick={handleSave} className='text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]' style={{ border: '1px solid #1F4CC8' }}>儲存</div>
          <div onClick={() => { setisEditingMissions(true) }} className='text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]' style={{ border: '1px solid #1F4CC8' }}>編輯閲讀任務</div>
        </div>
      </div>
      {/*end of buttons*/}

      <div className='w-full flex flex-row gap-[16px] mt-[16px] flex-wrap'>
        <div className='flex-[3] flex flex-col gap-[8px] min-w-[300px]'>
          <div className='font-[700]'>學校名稱</div>
          <input value={data?.name || ''} onChange={handleUpdateField('name')} placeholder='學校名稱' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
        </div>
        <div className='flex-[3] flex flex-col gap-[8px] min-w-[300px]'>
          <div className='font-[700]'>學校電話</div>
          <input value={data?.data?.telephone || ''} onChange={(e) => { setdata({ ...data, data: { ...(data?.data || {}), telephone: e.target.value } }) }} placeholder='電話' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
        </div>
        <div className='flex-[3] flex flex-col gap-[8px] min-w-[300px]'>
          <div className='font-[700]'>學校傳真</div>
          <input value={data?.data?.fax || ''} onChange={(e) => { setdata({ ...data, data: { ...(data?.data || {}), fax: e.target.value } }) }} placeholder='傳真' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
        </div>
        <div className='flex-[3] flex flex-col gap-[8px] min-w-[300px]'>
          <div className='font-[700]'>學校校長</div>
          <input value={data?.data?.principalName || ''} onChange={(e) => { setdata({ ...data, data: { ...(data?.data || {}), principalName: e.target.value } }) }} placeholder='學校校長' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
        </div>
        <div className='flex-[3] flex flex-col gap-[8px] min-w-[300px]'>
          <div className='font-[700]'>負責老師</div>
          <input value={data?.data?.teacherName || ''} onChange={(e) => { setdata({ ...data, data: { ...(data?.data || {}), teacherName: e.target.value } }) }} placeholder='負責老師' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
        </div>
        <div className='flex-[3] flex flex-col gap-[8px] min-w-[300px]'>
          <div className='font-[700]'>老師電話</div>
          <input value={data?.data?.teacherTel || ''} onChange={(e) => { setdata({ ...data, data: { ...(data?.data || {}), teacherTel: e.target.value } }) }} placeholder='老師電話' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
        </div>
        <div className='flex-[3] flex flex-col gap-[8px] min-w-[300px]'>
          <div className='font-[700]'>老師電郵</div>
          <input value={data?.data?.teacherEmail || ''} onChange={(e) => { setdata({ ...data, data: { ...(data?.data || {}), teacherEmail: e.target.value } }) }} placeholder='老師電郵' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
        </div>
        <div className='flex-[3] flex flex-col gap-[8px] min-w-[300px]'>
          <div className='font-[700]'>備注</div>
          <input value={data?.data?.remarks || ''} onChange={(e) => { setdata({ ...data, data: { ...(data?.data || {}), remarks: e.target.value } }) }} placeholder='備注' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
        </div>
      </div>
      <div className='w-full flex flex-row gap-[16px] mt-[16px] flex-wrap'>
        <div className='font-[700]'>附件:</div>
        {data?.data?.attachments?.map((item, index) =>
          <div key={item || index} className='items-center cursor-pointer hover:opacity-[.5]' onClick={openNewTab(item)}>
            <img className='w-[24px] h-[24px]' src='/images/file_icon.png' />
          </div>
        )}
      </div>


      {/*teacher*/}
      <div className='w-full flex flex-row gap-[48px] mt-[16px] flex-wrap justify-between items-center'>
        <div className='font-[700]'>老師資料</div>
        <div onClick={() => { setisAddingTeacher({}) }} className='text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]' style={{ border: '1px solid #1F4CC8' }}>
          添加
        </div>
      </div>


      {/*list of teachers*/}
      <div className='flex flex-col flex-1 w-full bg-[white] rounded-[10px] p-[16px] text-[14px]' style={{ overflowY: 'auto' }}>
        <div className='w-full flex flex-row justify-between font-bold py-[16px]' style={{ borderBottom: '1px solid #D1D1D1' }}>
          <div className='flex-1'>老師姓名</div>
          <div className='flex-1'>聯絡電話</div>
          <div className='flex-1'>電郵</div>
          <div className='flex-1'>狀態</div>
          <div className='w-[32px] mr-[8px]'></div>
          <div className='w-[32px]'></div>
        </div>
        {teachers?.map((item, index) =>
          <div key={item?._id || index} className='w-full flex flex-row justify-between font-[400] py-[16px] items-center' style={{ borderBottom: '1px solid #D1D1D1' }}>
            <div className='flex-1'>{item?.name}</div>
            <div className='flex-1'>{item?.mobile || ''}</div>
            <div className='flex-1'>{item?.username || ''}</div>
            <div className='flex-1 flex flex-row'>
              {item.status === 'active' ? <div className='text-[12px] rounded-[99px] px-[24px] py-[6px] bg-[#DBFFF0] text-[#4DE0A4]'>Active</div>
                : item.status === 'inactive' ? <div className='text-[12px] rounded-[99px] px-[24px] py-[6px] bg-[#FFC8C899] text-[#F06969]'>Inactive</div>
                  : <div>{item.status}</div>
              }
            </div>
            <div onClick={() => { setisAddingTeacher(item) }} className='w-[32px] bg-[#FFD8D0] h-[32px] rounded-[5px] flex justify-center items-center cursor-pointer hover:opacity-[.5] mr-[8px]'>
              <MoreSvg />
            </div>
            <div onClick={() => { setisDeletingUser(item) }} className='w-[32px] bg-[#E2E2E2] h-[32px] rounded-[5px] flex justify-center items-center cursor-pointer hover:opacity-[.5]'>
              <BinSvg />
            </div>
          </div>
        )}
      </div>
      {/*end of list of teachers*/}

      <div className='w-full flex flex-row gap-[48px] mt-[16px] flex-wrap justify-between items-center'>
        <div className='font-[700]'>學生資料</div>
        <div className='flex flex-row gap-[8px] flex-wrap items-center'>
          <div onClick={() => { setisAddingStudent({}) }} className='text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]' style={{ border: '1px solid #1F4CC8' }}>
            添加
          </div>
          <div onClick={() => { setisUploading([]) }} className='text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]' style={{ border: '1px solid #1F4CC8' }}>
            上傳學生名單
          </div>
        </div>
      </div>

      {/*list of students*/}
      <div className='flex flex-col flex-1 w-full bg-[white] rounded-[10px] p-[16px] text-[14px]' style={{ overflowY: 'auto' }}>
        <div className='w-full flex flex-row justify-between font-bold py-[16px]' style={{ borderBottom: '1px solid #D1D1D1' }}>
          <div className='flex-1'>學生姓名</div>
          <div className='flex-1'>性別</div>
          <div className='flex-1'>班級</div>
          <div className='flex-1'>電郵</div>
          <div className='flex-1'>狀態</div>
          <div className='w-[32px] mr-[8px]'></div>
          <div className='w-[32px]'></div>
        </div>
        {students?.map((item, index) =>
          <div key={item?._id || index} className='w-full flex flex-row justify-between font-[400] py-[16px] items-center' style={{ borderBottom: '1px solid #D1D1D1' }}>
            <div className='flex-1'>{item?.name}</div>
            <div className='flex-1'>{item?.gender}</div>
            <div className='flex-1'>{item?.class}</div>
            <div className='flex-1'>{item?.username}</div>
            <div className='flex-1 flex flex-row'>
              {item.status === 'active' ? <div className='text-[12px] rounded-[99px] px-[24px] py-[6px] bg-[#DBFFF0] text-[#4DE0A4]'>Active</div>
                : item.status === 'inactive' ? <div className='text-[12px] rounded-[99px] px-[24px] py-[6px] bg-[#FFC8C899] text-[#F06969]'>Inactive</div>
                  : <div>{item.status}</div>
              }
            </div>
            <div onClick={() => { setisAddingStudent(item) }} className='w-[32px] bg-[#FFD8D0] h-[32px] rounded-[5px] flex justify-center items-center cursor-pointer hover:opacity-[.5] mr-[8px]'>
              <MoreSvg />
            </div>
            <div onClick={() => { setisDeletingUser(item) }} className='w-[32px] bg-[#E2E2E2] h-[32px] rounded-[5px] flex justify-center items-center cursor-pointer hover:opacity-[.5]'>
              <BinSvg />
            </div>
          </div>
        )}
      </div>
      {/*end of list of students*/}


      {isEditingMissions && <EditSchoolMissionsPopup back={() => { setisEditingMissions(null) }} />}

      {/*add/edit teacher popup*/}
      {isAddingTeacher &&
        <div className='fixed top-0 left-0 w-full h-full bg-[#00000090] flex flex-col justify-center items-center'>
          <div className='flex flex-col gap-[8px] bg-[white] p-[16px] rounded-[7px] max-w-[400px] w-full'>
            <div className='font-[700]'>老師姓名</div>
            <input value={isAddingTeacher?.name} onChange={e => { setisAddingTeacher({ ...isAddingTeacher, name: e.target.value }) }} placeholder='姓名' className='rounded-[7px] px-[8px] py-[4px] font-[400]' style={{ border: '1px solid black' }} />
            <div className='font-[700]'>電郵</div>
            <input disabled={isAddingTeacher?._id} value={isAddingTeacher?.username} onChange={e => { setisAddingTeacher({ ...isAddingTeacher, username: e.target.value }) }} placeholder='電郵' className='rounded-[7px] px-[8px] py-[4px] font-[400]' style={{ border: '1px solid black' }} />
            <div className='font-[700]'>聯絡電話</div>
            <input value={isAddingTeacher?.mobile} onChange={e => { setisAddingTeacher({ ...isAddingTeacher, mobile: e.target.value }) }} placeholder='聯絡電話' className='rounded-[7px] px-[8px] py-[4px] font-[400]' style={{ border: '1px solid black' }} />
            {isAddingTeacher?._id ?
              <div />
              : <div className='font-[700]'>密碼</div>
            }
            {isAddingTeacher?._id ?
              <div />
              : <input value={isAddingTeacher?.password} onChange={e => { setisAddingTeacher({ ...isAddingTeacher, password: e.target.value }) }} placeholder='密碼' className='rounded-[7px] px-[8px] py-[4px] font-[400]' style={{ border: '1px solid black' }} />
            }

            <div className='w-full flex flex-row gap-[16px] mt-[16px] mb-[-16px] flex-wrap justify-center items-center'>
              {isAddingTeacher?._id && <div onClick={handleChangePassword(isAddingTeacher?._id)} className='text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]' style={{ border: '1px solid #1F4CC8' }}>
                更改密碼
              </div>}
              {isAddingTeacher?._id && <div onClick={()=>{setisResendingEmail(isAddingTeacher?.username)}} className='text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]' style={{ border: '1px solid #1F4CC8' }}>
                重新發送電子郵件
              </div>}
            </div>
            <div className='w-full flex flex-row gap-[16px] mt-[16px] flex-wrap justify-center items-center'>
              <div onClick={handleAddTeacher} className='text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]' style={{ border: '1px solid #1F4CC8' }}>
                {isAddingTeacher?._id ? '更新' : '添加'}
              </div>
              <div onClick={() => { setisAddingTeacher(null) }} className='text-[#1F4CC8] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5]' style={{ border: '1px solid #1F4CC8' }}>
                取消
              </div>
            </div>
          </div>
        </div>}
      {/*end of add/edit teacher popup*/}

      {/*add/edit student popup*/}
      {isAddingStudent &&
        <div className='fixed top-0 left-0 w-full h-full bg-[#00000090] flex flex-col justify-center items-center'>
          <div className='flex flex-col gap-[8px] bg-[white] p-[16px] rounded-[7px] max-w-[400px] w-full'>
            <div className='font-[700]'>學生姓名</div>
            <input value={isAddingStudent?.name} onChange={e => { setisAddingStudent({ ...isAddingStudent, name: e.target.value }) }} placeholder='姓名' className='rounded-[7px] px-[8px] py-[4px] font-[400]' style={{ border: '1px solid black' }} />
            <div className='font-700'>性別</div>
            <div className='flex flex-row gap-[8px] items-center'>
              <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                <button className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${isAddingStudent.gender === '男' ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                  onClick={() => { setisAddingStudent({ ...isAddingStudent, gender: '男' }) }}
                ></button>
              </div>
              <div>男</div>

              <div className='ml-[32px] flex bg-[#ddd] rounded-full p-[1px]'>
                <button className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${isAddingStudent.gender === '女' ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                  onClick={() => { setisAddingStudent({ ...isAddingStudent, gender: '女' }) }}
                ></button>
              </div>
              <div className=''>女</div>

            </div>
            <div className='font-700'>班級</div>
            <input value={isAddingStudent?.class} onChange={e => { setisAddingStudent({ ...isAddingStudent, class: e.target.value }) }} placeholder='班級' className='rounded-[7px] px-[8px] py-[4px] font-[400]' style={{ border: '1px solid black' }} />
            <div className='font-[700]'>電郵</div>
            <input disabled={isAddingStudent?._id} value={isAddingStudent?.username} onChange={e => { setisAddingStudent({ ...isAddingStudent, username: e.target.value }) }} placeholder='電郵' className='rounded-[7px] px-[8px] py-[4px] font-[400]' style={{ border: '1px solid black' }} />
            {isAddingStudent?._id ?
              <div />
              : <div className='font-[700]'>密碼</div>
            }
            {isAddingStudent?._id ?
              <div />
              : <input value={isAddingStudent?.password} onChange={e => { setisAddingStudent({ ...isAddingStudent, password: e.target.value }) }} placeholder='密碼' className='rounded-[7px] px-[8px] py-[4px] font-[400]' style={{ border: '1px solid black' }} />
            }
            <div className='w-full flex flex-row gap-[16px] mt-[16px] flex-wrap justify-center items-center'>
              {isAddingStudent?._id && <div onClick={handleChangePassword(isAddingStudent?._id)} className='text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]' style={{ border: '1px solid #1F4CC8' }}>
                更改密碼
              </div>}
              <div onClick={handleAddStudent} className='text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]' style={{ border: '1px solid #1F4CC8' }}>
                {isAddingStudent?._id ? '更新' : '添加'}
              </div>
              <div onClick={() => { setisAddingStudent(null) }} className='text-[#1F4CC8] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5]' style={{ border: '1px solid #1F4CC8' }}>
                取消
              </div>
            </div>
          </div>
        </div>
      }
      {/*end of add/edit student popup*/}

      {/*delete user popup*/}
      {isDeletingUser &&
        <div className='fixed top-0 left-0 w-full h-full bg-[#00000090] flex flex-col justify-center items-center'>
          <div className='flex flex-col gap-[8px] bg-[white] p-[16px] rounded-[7px] max-w-[400px] w-full'>
            <div className='font-[700]'>姓名:</div>
            <div> {isDeletingUser?.name} </div>
            <div className='font-[700]'>電郵:</div>
            <div> {isDeletingUser?.username} </div>
            <div className='w-full flex flex-row gap-[16px] mt-[24px] flex-wrap justify-center items-center'>
              <div onClick={handleDeleteUser} className='text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]' style={{ border: '1px solid #1F4CC8' }}>
                刪除
              </div>
              <div onClick={() => { setisDeletingUser(null) }} className='text-[#1F4CC8] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5]' style={{ border: '1px solid #1F4CC8' }}>
                取消
              </div>
            </div>
          </div>
        </div>
      }
      {/*end of delete user popup*/}

      {/*resend email popup*/}
      {isResendingEmail && <div className='fixed top-0 left-0 w-full h-full bg-[#00000090] flex flex-col justify-center items-center'>
        <div className='flex flex-col gap-[8px] bg-[white] p-[16px] rounded-[7px] max-w-[400px] w-full'>
          <div className='font-[700]'>重新發送電郵</div>
          <div className='text-[14px]'>確定要重新發送電郵到 {isResendingEmail} 嗎？</div>
          <div className='w-full flex flex-row gap-[16px] mt-[24px] flex-wrap justify-center items-center'>
            <div onClick={handleResendEmail} className='text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]' style={{ border: '1px solid #1F4CC8' }}>
              確認
            </div>
            <div onClick={() => { setisResendingEmail(null) }} className='text-[#1F4CC8] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5]' style={{ border: '1px solid #1F4CC8' }}>
              取消
            </div>
          </div>
        </div>
      </div>}

      {/*change password popup*/}
      {isChangingPassword && <div className='fixed top-0 left-0 w-full h-full bg-[#00000090] flex flex-col justify-center items-center'>
        <div className='flex flex-col gap-[8px] bg-[white] p-[16px] rounded-[7px] max-w-[400px] w-full'>
          <div className='font-[700]'>新密碼</div>
          <input value={isChangingPassword?.password} onChange={e => { setisChangingPassword({ ...isChangingPassword, password: e.target.value }) }} placeholder='密碼' className='rounded-[7px] px-[8px] py-[4px] font-[400]' style={{ border: '1px solid black' }} />
          <div className='w-full flex flex-row gap-[16px] mt-[24px] flex-wrap justify-center items-center'>
            <div onClick={handleConfirmChangePassword} className='text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]' style={{ border: '1px solid #1F4CC8' }}>
              確認
            </div>
            <div onClick={() => { setisChangingPassword(null) }} className='text-[#1F4CC8] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5]' style={{ border: '1px solid #1F4CC8' }}>
              取消
            </div>
          </div>
        </div>
      </div>}
      {/*end of change password popup*/}

      {/*upload student list popup*/}
      {isUploading && <div className='fixed top-0 left-0 w-full h-full bg-[#00000090] flex flex-col justify-center items-center'>
        <div className='flex flex-col gap-[8px] bg-[white] p-[16px] w-[100%] rounded-[7px] max-w-[700px] w-full max-h-[80vh] overflow-y-auto'>
          <div className='font-[700]'>上傳學生名單</div>
          <div className='flex flex-col' style={{}}>
            請上傳Excel檔案，格式如下：

            <img src='/upload_sample.png' className='w-full' />

            <b>Example header:</b>
            <div className='w-full flex flex-row justify-between items-stretch font-bold' style={{ border: '.5px solid black' }}>
              <div className='flex-1 p-[4px]' style={{ border: '.5px solid black' }}>Email</div>
              <div className='flex-1 p-[4px]' style={{ border: '.5px solid black' }}>Password</div>
              <div className='flex-1 p-[4px]' style={{ border: '.5px solid black' }}>Name</div>
              <div className='flex-[2] p-[4px]' style={{ border: '.5px solid black' }}>Gender (M/F/男/女)</div>
              <div className='flex-1 p-[4px]' style={{ border: '.5px solid black' }}>Class</div>
            </div>

            <div className='flex flex-row'>下載上傳文件樣本: <a className='ml-[10px] text-[blue]' href='/upload_sample.xlsx' download>upload_sample.xlsx</a></div>

            <input className='' type="file" onChange={handleUpload} style={{ marginTop: '24px' }} />

            <div className='font-[700] mt-[24px]'>上傳名單:</div>
            <div className='w-full flex flex-row justify-between font-[400] items-center font-bold text-[12px] mt-[20px]' style={{ borderBottom: '1px solid black' }}>
              <div className='flex-1'>學生電郵</div>
              <div className='flex-1'>學生姓名</div>
              <div className='flex-1'>學生性別</div>
              <div className='flex-1'>學生班級</div>
              <div className='w-[24px]'></div>
            </div>
            <div className='flex w-full flex-col gap-[8px] mt-[8px] overflow-y-auto text-[14px]' style={{ maxHeight: '300px' }}>
              {isUploading?.map?.((item, index) =>
                <div key={index} className='w-full flex flex-row justify-between font-[400] items-center' style={{ borderBottom: '1px solid #D1D1D1' }}>
                  <div className='flex-1'>{item?.username}</div>
                  <div className='flex-1'>{item?.name}</div>
                  <div className='flex-1'>{item?.gender}</div>
                  <div className='flex-1'>{item?.class}</div>
                  <div className='w-[24px]'>
                    <div onClick={() => { setisUploading(isUploading.filter((_, i) => i !== index)) }} className='w-[24px] h-[24px] flex justify-center items-center cursor-pointer hover:opacity-[.5]'>
                      <RemoveSvg />
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className='font-bold'>總數: {isUploading?.length || 0}</div>

            <div className='w-full flex flex-row gap-[16px] mt-[24px] flex-wrap justify-center items-center'>
              <div onClick={handleConfirmUpload} className='text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]' style={{ border: '1px solid #1F4CC8' }}>
                確認
              </div>
              <div onClick={() => { setisUploading(null) }} className='text-[#1F4CC8] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5]' style={{ border: '1px solid #1F4CC8' }}>
                取消
              </div>
            </div>
          </div>
        </div>
      </div>
      }

      {isLoading && <LoadingPage />}
    </div>
  );
}

export default connect((store) => {
  return {
    token: store.tokenReducer,
  }
})(Component)
